import { render, staticRenderFns } from "./laboratory.vue?vue&type=template&id=18dbf981&scoped=true&"
import script from "./laboratory.vue?vue&type=script&lang=js&"
export * from "./laboratory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18dbf981",
  null
  
)

export default component.exports